/**
 * Shared serial image warm-up queue for all preload modules.
 *
 * One request in flight at a time, at low fetch priority, deduped per file —
 * speculative warming must never compete with images the visitor actually
 * sees. Two buckets enforce the site-wide order: PROJECT imagery always
 * drains before the casual bucket (team panels, contact map, news teasers),
 * even when a project warm arrives while casual items are already waiting.
 * Callers do their own gating (fastConnection, prerendering, engine) — the
 * queue only orders, dedupes and throttles.
 */

const done = new Set()
const project = []
const casual = []
let warming = false

const next = () => {
  const item = project.shift() ?? casual.shift()
  if (!item) {
    warming = false
    return
  }
  warming = true
  const probe = new Image()
  probe.fetchPriority = 'low'
  probe.onload = probe.onerror = next
  if (item.srcset) {
    // sizes must be set before srcset so candidate selection sees it.
    probe.sizes = item.sizes || ''
    probe.srcset = item.srcset
  } else {
    probe.src = item.src
  }
}

// item: {src} or {srcset, sizes}; priority: 'project' | 'casual'
export const warmImage = (item, priority = 'casual') => {
  const key = item.srcset || item.src
  if (!key || done.has(key)) return
  done.add(key)
  ;(priority === 'project' ? project : casual).push(item)
  if (!warming) next()
}
